import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'app-collapse-job',
  templateUrl: './collapse-job.component.html',
  styleUrls: ['./collapse-job.component.scss']
})
export class CollapseJobComponent implements OnInit {

  @Input()
  header = 'Header'

  @ViewChild('collapseCard') elementView: ElementRef;
  viewHeight: number;

  isCollapse = true;

  constructor() { }

  toggleCollapse() {
    this.isCollapse = !this.isCollapse
    // console.log("this.isCollapse ", this.isCollapse);
    
  }
  
  ngOnInit() {
  }

  // ngAfterContentInit() {
  //   setTimeout(() => {
  //     this.viewHeight = this.elementView.nativeElement.offsetHeight;
  //   }, 1000);
  // }
}
